export const ADD_TABLE_TITLE = 'Ajouter un tableau';
export const MIN_TABLE_COL = 1;
export const MIN_TABLE_ROW = 1;
export const UPDATE_TABLE_TITLE = 'Modifier un tableau';
export const VALIDATE_LABEL = 'Valider';
